// Código da corretora do cliente: o identificador que o assessor usa (cadastro,
// CRM, header do Consolidador) e que a navegação 2026 exibe sob o nome.
//
// Este util existe porque o campo NÃO é confiável na origem: em produção 37% dos
// clientes não têm código, e 465 guardam a STRING `'None'` — o cadastro grava
// `str(dic_dados.get('codigo_corretora')) or None`, e `str(None)` é a string
// `'None'`, que é truthy. Sem tratar aqui, o assessor lê "None" sob o nome do
// cliente. Corrigir a origem não dispensa este util: os registros já gravados
// continuam no banco até um backfill.
//
// A lista foi MEDIDA em produção (24/08/2026): `none` = 465 clientes, `-` = 1.
// `null`, `nan` e `undefined` ficam porque são a mesma classe de defeito — o
// `str()`/`String()` de um valor nulo — e custam uma entrada de Set cada.
const PLACEHOLDERS = new Set(['none', 'null', 'nan', 'undefined', '-'])

/**
 * Normaliza o código da corretora para exibição e para busca.
 * @param {*} value  `codigo_corretora` cru (string, número, null)
 * @returns {string} o código limpo, ou '' quando não há código exibível
 */
export function formatBrokerCode(value) {
  if (value === null || value === undefined) return ''
  const code = String(value).trim()
  if (!code) return ''
  if (PLACEHOLDERS.has(code.toLowerCase())) return ''
  return code
}
